module.exports = __webpack_public_path__ + "img/section_bg1.8271b8f8.png";